module.exports = __webpack_public_path__ + "img/Google Button.4e82bb4c.svg";